import React from "react";
import { Search } from "lucide-react";
import Button from "components/ui/Button";

export const statusFilterOptions = [
  { value: "all", label: "Todos" },
  { value: "available", label: "Disponible" },
  { value: "sold_out", label: "Agotado" },
  { value: "hidden", label: "Oculto" },
];

export default function ProductFilters({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  resultsCount = 0,
  onClearFilters,
}) {
  const hasActiveFilters = Boolean(searchQuery?.trim()) || statusFilter !== "all";

  const badgeClass = (active) =>
    [
      "inline-flex items-center justify-center rounded-full px-3 py-1.5 text-xs font-semibold transition-all duration-150",
      "font-[family-name:var(--font-caption)] border",
      active
        ? "border-slate-950 bg-slate-950 text-white shadow-[0_8px_18px_rgba(15,23,42,0.12)]"
        : "border-slate-200/80 bg-white/70 text-slate-600 hover:border-slate-300 hover:bg-white",
    ].join(" ");

  return (
    <div className="space-y-3">
      {/* Search */}
      <div className="relative w-full">
        <span className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-slate-400">
          <Search className="h-4 w-4" strokeWidth={2} aria-hidden />
        </span>
        <input
          type="search"
          placeholder="Buscar en el catálogo..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full rounded-xl border border-slate-200/80 bg-white/86 py-2.5 pl-10 pr-4 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-900/5 font-[family-name:var(--font-body)]"
        />
      </div>

      {/* Status filter + results count */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-col gap-2 min-w-0">
          <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500 font-[family-name:var(--font-caption)]">
            Estado de venta
          </span>
          <div className="flex flex-wrap gap-2">
            {statusFilterOptions?.map((opt) => (
              <button
                key={opt?.value}
                type="button"
                onClick={() => onStatusChange(opt?.value)}
                className={badgeClass(statusFilter === opt?.value)}
              >
                {opt?.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 pb-0.5">
          <span className="text-sm text-slate-500 whitespace-nowrap font-[family-name:var(--font-caption)]">
            {resultsCount} resultado{resultsCount !== 1 ? "s" : ""}
          </span>
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="text-slate-600 hover:text-slate-900"
              iconName="X"
              iconPosition="left"
              iconSize={14}
            >
              Limpiar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
